 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1PASTANDPRESENTLIFE from '@/components/0_chapter1pastandpresentlife'
 import A_CHAPTER2PERNICIOUSTAOIST from '@/components/1_chapter2pernicioustaoist'
 import A_CHAPTER3GUESTFROMAFAR from '@/components/2_chapter3guestfromafar'
 import A_CHAPTER4SENDINGPEOPLE from '@/components/3_chapter4sendingpeople'
 import A_CHAPTER5HUNDREDDAMAGEAPPEARANCE from '@/components/4_chapter5hundreddamageappearance'
 import A_CHAPTER6VICTORY from '@/components/5_chapter6victory'
 import A_CHAPTER7MASTERANDDISCIPLEDEBATEONTHEDAO from '@/components/6_chapter7masteranddiscipledebateonthedao'
 import A_CHAPTER8REALM from '@/components/7_chapter8realm'
 import A_CHAPTER9THEWAYOFTHEINNATE from '@/components/8_chapter9thewayoftheinnate'
 import A_CHAPTER10PERFORMINGARTS from '@/components/9_chapter10performingarts'
 import A0_CHAPTER11IMPARTING from '@/components/10_chapter11imparting'
 import A1_CHAPTER12FIRSTBATTLE from '@/components/11_chapter12firstbattle'
 import A2_CHAPTER13EARLYENTRYINTOTHEMARTIALARTSWORLD from '@/components/12_chapter13earlyentryintothemartialartsworld'
 import A3_CHAPTER14RIDINGTHEHORSETOTIANSHANMOUNTAIN from '@/components/13_chapter14ridingthehorsetotianshanmountain'
 import A4_CHAPTER15DUOSHA from '@/components/14_chapter15duosha'
 import A5_CHAPTER16PROGRESSIVECULTIVATION from '@/components/15_chapter16progressivecultivation'
 import A6_CHAPTER17UNEXPECTED from '@/components/16_chapter17unexpected'
 import A7_CHAPTER18SHOCKCHANGE from '@/components/17_chapter18shockchange'
 import A8_CHAPTER19TRAPPED from '@/components/18_chapter19trapped'
 import A9_CHAPTER20DEBAO from '@/components/19_chapter20debao'
 import A0_CHAPTER21INTERNALDISORDEROFMINGRELIGION from '@/components/20_chapter21internaldisorderofmingreligion'
 import A1_CHAPTER22RELIEVING from '@/components/21_chapter22relieving'
 import A2_CHAPTER23BACKTOTHEMOUNTAIN from '@/components/22_chapter23backtothemountain'
 import A3_CHAPTER24NEWYEAR from '@/components/23_chapter24newyear'
 import A4_CHAPTER25PUREYANGINFINITETECHNIQUE from '@/components/24_chapter25pureyanginfinitetechnique'
 import A5_CHAPTER26RAGEKILLING from '@/components/25_chapter26ragekilling'
 import A6_CHAPTER27NIGHTSCOUTCAMP from '@/components/26_chapter27nightscoutcamp'
 import A7_CHAPTER28RESCUE from '@/components/27_chapter28rescue'
 import A8_CHAPTER29CROSS from '@/components/28_chapter29cross'
 import A9_CHAPTER30BEHEADING from '@/components/29_chapter30beheading'
 import A0_CHAPTER31XUANMINGSUZHOU from '@/components/30_chapter31xuanmingsuzhou'
 import A1_CHAPTER32FIRSTTRIMESTEROFXUANMING from '@/components/31_chapter32firsttrimesterofxuanming'
 import A2_CHAPTER33FIRSTMEETINGINTHENETHERWORLD from '@/components/32_chapter33firstmeetinginthenetherworld'
 import A3_CHAPTER34ESCAPE from '@/components/33_chapter34escape'
 import A4_CHAPTER35CALCULATION from '@/components/34_chapter35calculation'
 import A5_CHAPTER36RELIEVING from '@/components/35_chapter36relieving'
 import A6_CHAPTER37HELPER from '@/components/36_chapter37helper'
 import A7_CHAPTER38BROKENTEMPLE from '@/components/37_chapter38brokentemple'
 import A8_CHAPTER39DISPUTE from '@/components/38_chapter39dispute'
 import A9_CHAPTER40REASONS from '@/components/39_chapter40reasons'
 import A0_CHAPTER41CONFIDE from '@/components/40_chapter41confide'
 import A1_CHAPTER42BONEPALPATION from '@/components/41_chapter42bonepalpation'
 import A2_CHAPTER43MASTER from '@/components/42_chapter43master'
 import A3_CHAPTER44GRUDGES from '@/components/43_chapter44grudges'
 import A4_CHAPTER45STIRRINGUPTROUBLE from '@/components/44_chapter45stirringuptrouble'
 import A5_CHAPTER46QUESTIONPARTI from '@/components/45_chapter46questionparti'
 import A6_CHAPTER47QUESTIONPARTII from '@/components/46_chapter47questionpartii'
 import A7_CHAPTER48DEBAO from '@/components/47_chapter48debao'
 import A8_CHAPTER49MURONGMU from '@/components/48_chapter49murongmu'
 import A9_CHAPTER50OPINION from '@/components/49_chapter50opinion'
 import A0_CHAPTER51BUSY from '@/components/50_chapter51busy'
 import A1_CHAPTER52APOTHECARY from '@/components/51_chapter52apothecary'
 import A2_CHAPTER53ALCHEMY from '@/components/52_chapter53alchemy'
 import A3_CHAPTER54SPARRING from '@/components/53_chapter54sparring'
 import A4_CHAPTER55PILLS from '@/components/54_chapter55pills'
 import A5_CHAPTER56COMPREHENSION from '@/components/55_chapter56comprehension'
 import A6_CHAPTER57DOWNHILL from '@/components/56_chapter57downhill'
 import A7_CHAPTER58BANDITS from '@/components/57_chapter58bandits'
 import A8_CHAPTER59BEHEADTHEENEMY from '@/components/58_chapter59beheadtheenemy'
 import A9_CHAPTER60ACCIDENTALCHANGE from '@/components/59_chapter60accidentalchange'
 import A0_CHAPTER61BANDITS from '@/components/60_chapter61bandits'
 import A1_CHAPTER62MOUNTAINSTRONGHOLD from '@/components/61_chapter62mountainstronghold'
 import A2_CHAPTER63TAILING from '@/components/62_chapter63tailing'
 import A3_CHAPTER64ONTHEGIRL from '@/components/63_chapter64onthegirl'
 import A4_CHAPTER65YOUNGGIRL from '@/components/64_chapter65younggirl'
 import A5_CHAPTER66YOUNGGIRLSLOWERBODY from '@/components/65_chapter66younggirlslowerbody'
 import A6_CHAPTER67WAITING from '@/components/66_chapter67waiting'
 import A7_CHAPTER68BREAKTHROUGH from '@/components/67_chapter68breakthrough'
 import A8_CHAPTER69EXPOSURE from '@/components/68_chapter69exposure'
 import A9_CHAPTER70DELIBERATION from '@/components/69_chapter70deliberation'
 import A0_CHAPTER71ACTION from '@/components/70_chapter71action'
 import A1_CHAPTER72HEALINGINJURY from '@/components/71_chapter72healinginjury'
 import A2_CHAPTER73AWAKENING from '@/components/72_chapter73awakening'
 import A3_CHAPTER74MESOSCALE from '@/components/73_chapter74mesoscale'
 import A4_CHAPTER75DETACH from '@/components/74_chapter75detach'
 import A5_CHAPTER76DETACHING from '@/components/75_chapter76detaching'
 import A6_CHAPTER77OLDWOUNDSAREDIFFICULTTOHEAL from '@/components/76_chapter77oldwoundsaredifficulttoheal'
 import A7_CHAPTER78ENTERTHEBEARDEDCOUPLE from '@/components/77_chapter78enterthebeardedcouple'
 import A8_CHAPTER79AMONGTHEBEARDEDCOUPLES from '@/components/78_chapter79amongthebeardedcouples'
 import A9_CHAPTER80THEBEARDEDCOUPLE from '@/components/79_chapter80thebeardedcouple'
 import A0_CHAPTER81PAST from '@/components/80_chapter81past'
 import A1_CHAPTER82DARKSURGE from '@/components/81_chapter82darksurge'
 import A2_CHAPTER83UPPERMOSTDISORDER from '@/components/82_chapter83uppermostdisorder'
 import A3_CHAPTER84CHAOTICONSET from '@/components/83_chapter84chaoticonset'
 import A4_CHAPTER85INCEST from '@/components/84_chapter85incest'
 import A5_CHAPTER86POISONING from '@/components/85_chapter86poisoning'
 import A6_CHAPTER87ATTACKINGMOUNTAINS from '@/components/86_chapter87attackingmountains'
 import A7_CHAPTER88RUTHLESSNESS from '@/components/87_chapter88ruthlessness'
 import A8_CHAPTER89INTERNALSTRIFE from '@/components/88_chapter89internalstrife'
 import A9_CHAPTER90ARSON from '@/components/89_chapter90arson'
 import A0_CHAPTER91INJURIESTOBOTHSIDES from '@/components/90_chapter91injuriestobothsides'
 import A1_CHAPTER92MANTISANDCICADA from '@/components/91_chapter92mantisandcicada'
 import A2_CHAPTER93YELLOWSPARROWBEHIND from '@/components/92_chapter93yellowsparrowbehind'
 import A3_CHAPTER94FORCING from '@/components/93_chapter94forcing'
 import A4_CHAPTER95DECAPITATEDENEMY from '@/components/94_chapter95decapitatedenemy'
 import A5_CHAPTER96GO from '@/components/95_chapter96go'
 import A6_CHAPTER97LEAVE from '@/components/96_chapter97leave'
 import A7_CHAPTER98EPIMEDIUM from '@/components/97_chapter98epimedium'
 import A8_CHAPTER99MIDDLEEMEI from '@/components/98_chapter99middleemei'
 import A9_CHAPTER100EYEBROWSUBARACHNOID from '@/components/99_chapter100eyebrowsubarachnoid'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1pastandpresentlife",
 			"name" : "0_chapter1pastandpresentlife",
 			"component" : A_CHAPTER1PASTANDPRESENTLIFE
 		},
 		{
 			"path" : "/1_chapter2pernicioustaoist",
 			"name" : "1_chapter2pernicioustaoist",
 			"component" : A_CHAPTER2PERNICIOUSTAOIST
 		},
 		{
 			"path" : "/2_chapter3guestfromafar",
 			"name" : "2_chapter3guestfromafar",
 			"component" : A_CHAPTER3GUESTFROMAFAR
 		},
 		{
 			"path" : "/3_chapter4sendingpeople",
 			"name" : "3_chapter4sendingpeople",
 			"component" : A_CHAPTER4SENDINGPEOPLE
 		},
 		{
 			"path" : "/4_chapter5hundreddamageappearance",
 			"name" : "4_chapter5hundreddamageappearance",
 			"component" : A_CHAPTER5HUNDREDDAMAGEAPPEARANCE
 		},
 		{
 			"path" : "/5_chapter6victory",
 			"name" : "5_chapter6victory",
 			"component" : A_CHAPTER6VICTORY
 		},
 		{
 			"path" : "/6_chapter7masteranddiscipledebateonthedao",
 			"name" : "6_chapter7masteranddiscipledebateonthedao",
 			"component" : A_CHAPTER7MASTERANDDISCIPLEDEBATEONTHEDAO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js